// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2aeAT","emails":"CreateEditClinics_emails__1sfuz","emailTagLabel":"CreateEditClinics_emailTagLabel__2WigJ"};